"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_router_dom_2 = require("react-router-dom");
var material_1 = require("@mui/material");
var axios_1 = __importDefault(require("axios"));
var Lang_js_1 = require("../Lang.js");
var mountIsland_1 = require("../mountIsland");
var react_google_recaptcha_1 = __importDefault(require("react-google-recaptcha"));
function handleCaptcha(value) {
    var captchaValue = document.querySelector('#captchaValue');
    if (captchaValue) {
        captchaValue.value = value !== null && value !== void 0 ? value : '';
    }
}
function resetCaptcha() {
    var captchaRef = typeof window.captchaRef !== 'undefined' ? window.captchaRef : { reset: function () { } };
    var captchaValue = document.querySelector('#captchaValue');
    if (captchaValue) {
        captchaValue.value = '';
    }
    captchaRef.reset();
}
function Login() {
    var _a;
    var _b = (0, react_1.useState)(''), loginAlert = _b[0], setLoginAlert = _b[1];
    var _c = (0, react_1.useState)(false), showLoginAlert = _c[0], setShowLoginAlert = _c[1];
    var _d = (0, react_1.useState)(false), showCaptcha = _d[0], setShowCaptcha = _d[1];
    var searchParams = (0, react_router_dom_1.useSearchParams)()[0];
    var previous_url = (_a = searchParams.get('previous_url')) !== null && _a !== void 0 ? _a : '/';
    var sitekey = typeof window.captcha_sitekey === 'string' && window.captcha_sitekey.length > 0
        ? window.captcha_sitekey
        : '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';
    var handleSubmit = function (event) {
        event.preventDefault();
        var formData = new FormData(event.currentTarget);
        axios_1.default.post('/api/v2/students/login', formData).then(function (response) {
            if (typeof response.data === 'object') {
                if (typeof response.data.data.token !== 'undefined' &&
                    response.data.data.token !== '00000000000000000000000000') {
                    // User is logged in
                    var previousUrlEl = document.querySelector('#previousUrl');
                    var redirectUrl = previousUrlEl ? previousUrlEl.value : '/';
                    if (redirectUrl.charAt(0) === '/') {
                        window.location.href = redirectUrl;
                    }
                    else {
                        if (document.documentElement.getAttribute('lang') === 'es') {
                            window.location.href = '/es/';
                        }
                        else {
                            window.location.href = '/';
                        }
                    }
                    return;
                }
                // User is not logged in
                if (response.data.msg && response.data.msg.trim().length > 0) {
                    setLoginAlert(response.data.msg);
                    setShowLoginAlert(true);
                }
                if (response.data.rate_limit_show_captcha) {
                    setShowLoginAlert(true);
                }
            }
            else {
                setLoginAlert((0, Lang_js_1.__)('Please enter a valid login and password'));
                setShowLoginAlert(true);
            }
            resetCaptcha();
        }).catch(function (error) {
            var _a, _b;
            if (error.response) {
                if (error.response.data.msg) {
                    setLoginAlert(error.response.data.msg);
                }
            }
            else if (error.request) {
                setLoginAlert((0, Lang_js_1.__)('An error occured. Please try again later'));
            }
            else {
                setLoginAlert((0, Lang_js_1.__)('An error occured: ') + error.messagae);
            }
            setShowLoginAlert(true);
            if ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.rate_limit_show_captcha) {
                setShowCaptcha(true);
            }
            resetCaptcha();
        });
    };
    return (react_1.default.createElement(material_1.Container, { maxWidth: "xs" },
        react_1.default.createElement(material_1.CssBaseline, null),
        react_1.default.createElement(material_1.Box, { sx: {
                marginTop: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            } },
            react_1.default.createElement(material_1.Typography, { component: "h1", variant: "inherit" }, (0, Lang_js_1.__)('Please Log In')),
            react_1.default.createElement(material_1.Box, { component: "form", onSubmit: handleSubmit },
                react_1.default.createElement(material_1.TextField, { margin: "normal", required: true, fullWidth: true, id: "loginOrEmail", label: (0, Lang_js_1.__)('Login'), name: "login", autoComplete: "login", autoFocus: true }),
                react_1.default.createElement(material_1.TextField, { margin: "normal", required: true, fullWidth: true, name: "password", label: (0, Lang_js_1.__)('Password'), type: "password", id: "password", autoComplete: "current-password" }),
                react_1.default.createElement(material_1.TextField, { name: "previous_url", label: "", type: "hidden", id: "previousUrl", value: previous_url.replace(/lang=[a-z]{2}/, '') }),
                react_1.default.createElement(material_1.TextField, { name: "lang", label: "", type: "hidden", id: "lang", value: Lang_js_1.lang }),
                react_1.default.createElement(material_1.TextField, { name: "captchaValue", label: "", type: "hidden", id: "captchaValue" }),
                react_1.default.createElement(material_1.Zoom, { in: showCaptcha }, showCaptcha ? (react_1.default.createElement(react_google_recaptcha_1.default, { id: "captcha", sitekey: sitekey, onChange: handleCaptcha, ref: function (e) { window.captchaRef = e; } })) : (react_1.default.createElement("div", null))),
                react_1.default.createElement(material_1.Zoom, { in: showLoginAlert }, showLoginAlert ? (react_1.default.createElement(material_1.Alert, { severity: "error", id: "loginResponse" }, loginAlert)) : (react_1.default.createElement("div", null))),
                react_1.default.createElement(material_1.Button, { fullWidth: true, variant: "contained", type: "submit", sx: { mt: 3, mb: 2 }, size: "large" }, (0, Lang_js_1.__)('Login'))))));
}
exports.default = Login;
var loginFormEl = document.getElementById('loginForm');
if (loginFormEl) {
    axios_1.default.get('/api/v2/students/status')
        .then(function (response) {
        (0, mountIsland_1.mountIsland)(loginFormEl, react_1.default.createElement(react_router_dom_2.BrowserRouter, null,
            react_1.default.createElement(material_1.Container, { maxWidth: "xs" },
                react_1.default.createElement(material_1.CssBaseline, null),
                react_1.default.createElement(material_1.Box, { sx: {
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    } },
                    react_1.default.createElement(material_1.Typography, { component: "h1", variant: "h5", align: "center" }, (0, Lang_js_1.__)('You are currently logged in as ') + response.data.user.user_login),
                    react_1.default.createElement(material_1.Button, { fullWidth: true, variant: "contained", sx: { mt: 3, mb: 2 }, href: "/app/students/logout" }, (0, Lang_js_1.__)('Log Out'))))));
    })
        .catch(function (error) {
        console.log(error);
        (0, mountIsland_1.mountIsland)(loginFormEl, react_1.default.createElement(react_router_dom_2.BrowserRouter, null,
            react_1.default.createElement(Login, null)));
    });
}
